import { MTableBody } from 'material-table';
import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export function numberFormatProps() {
  return {
    isAllowed: values => {
      const { formattedValue, floatValue } = values;
      return formattedValue === '' || floatValue <= 9999999999999;
    },
    decimalSeparator: ',',
    thousandSeparator: ' ',
  };
}

export function loadDefaultFilter(tableKey, column) {
  const table_filters = JSON.parse(localStorage.getItem('table_filters')) || {};

  // (17-07-2025) This is a hack to ensure that we're able to hide and show columns via the toggle
  // This seems a bit backward, but there is a function not related at all to column visibility in `material-table`
  // that assume that this value will be set. The real fix would be to get rid of `material-table` since it's not maintained anymore
  column.tableData = {
    width: 'auto',
  };

  if (table_filters && table_filters[tableKey]) {
    column.defaultFilter = table_filters[tableKey][column.field];
  }

  const column_filters =
    JSON.parse(localStorage.getItem('column_filters')) || {};
  if (
    column_filters &&
    column_filters[tableKey] &&
    column_filters[tableKey][column.field] !== undefined
  ) {
    column.hidden = column_filters[tableKey][column.field];

    if (column.hidden) {
      column.hiddenByColumnsButton = true;
    }
  }

  return column;
}

export function materialTableProps(
  tableKey = null,
  exportFilename = 'export',
  isHome = false
) {
  setTimeout(() => {
    //  HACK - delete pdf button export
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(addedNode => {
          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            const element = addedNode;
            if (element.classList.contains('MuiPopover-root')) {
              Array.from(
                element.getElementsByClassName('MuiMenuItem-root')
              ).forEach(menuItem => {
                if (menuItem.textContent === 'Export as PDF') {
                  menuItem.remove();
                }
              });
            }
          }
        });
      });
    }).observe(document.body, { childList: true });
  }, 0);

  return {
    components: {
      Body: props => (
        <MTableBody
          {...props}
          onFilterChanged={(columnId, value) => {
            props.onFilterChanged(columnId, value);
            if (tableKey) {
              const currentFilters = JSON.parse(
                localStorage.getItem('table_filters')
              );
              var newFilters = { ...currentFilters };
              if (!newFilters[tableKey]) newFilters[tableKey] = {};
              newFilters[tableKey][props.columns[columnId].field] = value;
              localStorage.setItem('table_filters', JSON.stringify(newFilters));
            }
          }}
        />
      ),
    },
    onChangeColumnHidden: (column, hidden) => {
      if (tableKey) {
        const currentFilters = JSON.parse(
          localStorage.getItem('column_filters')
        );
        var newFilters = { ...currentFilters };
        if (!newFilters[tableKey]) newFilters[tableKey] = {};
        newFilters[tableKey][column.field] = hidden;
        localStorage.setItem('column_filters', JSON.stringify(newFilters));
      }
    },
    localization: {
      body: {
        emptyDataSourceMessage: 'Aucune donnée',
        filterRow: {
          filterTooltip: 'Filtre',
        },
      },
      pagination: {
        labelDisplayedRows: '{from}-{to} de {count}',
        labelRowsSelect: 'ligne(s)',
        labelRowsPerPage: '',
        firstTooltip: 'Première page',
        previousTooltip: 'Page précédente',
        nextTooltip: 'Page suivante',
        lastTooltip: 'Dernière page',
      },
      toolbar: {
        exportTitle: 'Exporter',
        exportCSVName: 'Exporter en fichier Excel',
        addRemoveColumns: 'Colonne(s) à afficher',
        showColumnsTitle: 'Colonne(s) à afficher',
      },
      header: {
        actions: 'Actions',
      },
    },
    options: {
      toolbar: !isHome,
      emptyRowsWhenPaging: false,
      sorting: true,
      draggable: false,
      filtering: true,
      exportButton: {
        csv: true,
      },
      showTitle: false,
      search: false,
      columnsButton: true,
      pageSize: 50,
      actionsColumnIndex: -1,
      pageSizeOptions: [5, 10, 15, 20, 25, 50, 100, 150, 200, 500],
      headerStyle: {},
      rowStyle: rowData => ({
        backgroundColor:
          rowData.disabled === true || rowData.disabled === 1
            ? 'rgba(219, 55, 57, 0.1)'
            : '',
      }),
      exportCsv: async (columns, data) => {
        const col = columns.filter(
          col => col.hidden === false || col.hidden === undefined
        );

        const d = data.map(el => {
          var d = {};
          col.forEach(c => {
            var val = '';
            if (c.render) {
              val = c.render(el);
            } else if (c.lookup) {
              val = c.lookup[c.field];
            } else if (c.type === 'boolean') {
              if (el[c.field] === true) val = 'Non';
              else if (el[c.field] === false) val = 'Oui';
              else val = '';
            } else {
              val = el[c.field];
            }

            try {
              d[c.title] = val ? val.trim() : val;
            } catch (e) {
              d[c.title] = String(val);
            }
          });
          return d;
        });

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Define columns from the filtered column headers
        worksheet.columns = col.map(c => ({
          header: c.title,
          key: c.title,
        }));

        worksheet.addRows(d);
        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          `${exportFilename}.xlsx`
        );
      },
    },
  };
}
